import { Box, styled } from '@mui/material';

export const CompanyCardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  height: '240px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  [theme.breakpoints.down(600)]: {
    height: '200px',
  },
}));

export const TextContainer = styled(Box)(() => ({
  width: '100%',
  height: '60%',
}));

export const CompanyCardLocationContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: '-webkit-box',
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  [theme.breakpoints.down(600)]: {
    display: 'none',
  },
}));

export const CompanyCardCountryContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'block',
  textAlign: 'center',
  fontSize: '16px',
  lineHeight: '20px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down(600)]: {
    display: 'none',
  },
}));

export const CompanyCardPhotoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  height: '40%',
  [theme.breakpoints.down(600)]: {
    height: '50%',
  },
}));

export const CompanyCardNameContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'block',
  textAlign: 'center',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down(600)]: {
    height: '30%',
  },
}));
